import React, { Children, createContext, useState } from 'react';

export const UserContext = createContext({});

interface ContextProviderProps {
  children: any;
}

export function UserContextProvider({ children }: ContextProviderProps) {
  const [userInfo, setUserInfo] = useState({});

  return <UserContext.Provider value={{ userInfo, setUserInfo }}>{children}</UserContext.Provider>;
}
